<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>DiCentral Platform</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>

    <main id="cont">
      <div class="subCon caseCon">
        <section id="ediplatform">
          <h3 class="con_tit" style="font-size: 32px">DiCentral Platform</h3>

          <div class="inner_box">
            <section class="subsc">
              <h4 class="con_subtit" style="font-size: 30px">
                DiCentral의 Cloud 시스템은 이행 발송, 수취 프로세스를
                자동화함으로써 비즈니스 변화에 신속하게 대응하고, 시간 장소에
                구애 받지 않는 시스템 구축이 가능합니다. 또, 물류시스템의
                효율성을 향상시키는 데 도움이 됩니다. 생산업자, 유통 업체, 3PL의
                어느 것이라도 우리의 실시간 EDI 솔루션은 물류시스템의 완벽한
                가시성을 보장합니다. 사용자 정의 기능, 강력한 비즈니스 규칙
                모니터링, 모바일 EDI 등 다양한 분야에서 한발 앞서 갈 수
                있습니다.
              </h4>
              <br /><br /><br /><br /><br /><br /><br />
              <ul class="imgLst item6">
                <li>
                  <v-img
                    src="@/assets/img/dicentral/ediplatform/cloud.png"
                    style="margin: 0 auto; width: 150px; align-items: center"
                  />
                </li>
                <li>
                  <v-img
                    src="@/assets/img/dicentral/ediplatform/partner.png"
                    style="margin: 0 auto; width: 220px; align-items: center"
                  />
                </li>
                <li>
                  <v-img
                    src="@/assets/img/dicentral/ediplatform/integration.png"
                    style="margin: 0 auto; width: 180px; align-items: center"
                  />
                </li>
                <li>
                  <v-img
                    src="@/assets/img/dicentral/ediplatform/dropship.png"
                    style="margin: 0 auto; width: 150px; align-items: center"
                  />
                </li>
                <li>
                  <v-img
                    src="@/assets/img/dicentral/ediplatform/mobile.png"
                    style="margin: 0 auto; width: 170px; align-items: center"
                  />
                </li>
              </ul>

              <br /><br /><br /><br /><br /><br />
              <div style="margin-bottom: 100px; margin-top: 100px">
                <v-img
                  src="@/assets/img/dicentral/ediplatform/processing.png"
                />
              </div>
              <br /><br /><br />
              <div style="margin-bottom: 100px">
                <v-img
                  src="@/assets/img/dicentral/ediplatform/processing_2.png"
                />
              </div>
            </section>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
